import React from "react";
import { Check, Loader2, Radio } from "lucide-react";
import { STEPS, STATUS } from "./studioUtils";

const LABELS = { analyzing: "Analyse IA", draft: "Plan", test: "Test", ready: "Prêt", published: "Publié" };

/** Frise des étapes d'un module : analyse → plan → test → prêt → publié. `live` = une version est en ligne chez les clients. */
export function StepBar({ status, live, running }) {
  const cur = STEPS.indexOf(status);
  return (
    <div className="bg-white border border-[#DEE2E6] p-4 flex flex-wrap items-center gap-3" data-testid="studio-stepbar" data-status={status}>
      <ol className="flex flex-1 flex-wrap items-center gap-1 min-w-[280px]">
        {STEPS.map((s, i) => {
          const done = i < cur || status === "published";
          const active = i === cur;
          return (
            <li key={s} className="flex items-center gap-1" data-testid={`studio-step-${s}`} data-state={done ? "done" : active ? "active" : "todo"}>
              <span className={`h-7 w-7 flex items-center justify-center text-[11px] font-black border ${done ? "bg-[#059669] border-[#059669] text-white" : active ? "bg-[#0A0A0A] border-[#0A0A0A] text-[#FFD700]" : "bg-white border-[#DEE2E6] text-[#ADB5BD]"}`}>
                {done ? <Check className="h-3.5 w-3.5" /> : active && running ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : i + 1}
              </span>
              <span className={`text-[11px] uppercase tracking-wider font-bold ${active ? "text-[#0A0A0A]" : done ? "text-[#059669]" : "text-[#ADB5BD]"}`}>{LABELS[s]}</span>
              {i < STEPS.length - 1 && <span className={`mx-1.5 h-px w-6 lg:w-10 ${done ? "bg-[#059669]" : "bg-[#DEE2E6]"}`} />}
            </li>
          );
        })}
      </ol>
      <div className="flex items-center gap-2">
        <span className={`inline-flex items-center text-[10px] uppercase tracking-wider font-bold px-2 py-1 border ${STATUS[status]?.cls || ""}`} data-testid="studio-status-badge">{STATUS[status]?.label || status}</span>
        {live && <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-bold px-2 py-1 bg-[#0A0A0A] text-[#FFD700]" data-testid="studio-live-badge"><Radio className="h-3 w-3" />En ligne</span>}
      </div>
    </div>
  );
}
